import { createSvgIcon } from '@mui/material';

export const CheckmarkIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none">
    <g clipPath="url(#clip0_1_1501)">
      <path
        d="M2.29883 7.00078L5.29883 11.2008L13.0988 2.80078"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_1501">
        <rect
          width="13.7143"
          height="13.7143"
          fill="currentColor"
          transform="translate(0.642578 0.143066)"
        />
      </clipPath>
    </defs>
  </svg>,
  'Checkmark',
);
